import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { handleApiCall } from "../../../apis";
import { endpoints } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";
import he from "he";

const TermsAndConditions = ({ role }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState("");
  const [dataArabic, setDataArabic] = useState("");

  const getCms = useCallback(async () => {
    if (!role) return;

    setLoading(true);
    setError(false);
    try {
      const params = new URLSearchParams({
        type: "term_and_condition",
      });

      const response = await handleApiCall("get", `${endpoints.getContent}?${params}`);

      if (response?.data?.code === 200 || response?.data?.code === "200") {
        const item =
          response?.data?.data?.description_en ||
          response?.data?.data?.description ||
          response?.data?.data?.content ||
          response?.data?.data?.data?.description_en ||
          response?.data?.data?.data?.description ||
          response?.data?.data?.data?.content;
        const itemArabic = response?.data?.data?.description_ar || response?.data?.data?.data?.description_ar || "";

        const decoded = he.decode(item || ""); // decode HTML entities
        const sanitized = DOMPurify.sanitize(decoded); // sanitize the HTML
        setData(sanitized);

        const decodedArabic = he.decode(itemArabic || "");
        setDataArabic(DOMPurify.sanitize(decodedArabic));
      }
      // API errors are already handled by handleApiCall
    } catch (error) {
      console.error("Error fetching Terms and Conditions:", error);
      setError(true);
      // Network errors are already handled by handleApiCall
    } finally {
      setLoading(false);
    }
  }, [role]);

  useEffect(() => {
    getCms();
  }, [getCms]);

  if (loading) {
    return (
      <div className="card mb-4 px-4 py-4 mt-2" style={{ width: "100%" }}>
        <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card mb-4 px-4 py-4 mt-2" style={{ width: "100%" }}>
        <div className="text-center py-5">
          <p className="text-danger">Failed to load Terms and Conditions</p>
          <button className="btn btn-primary" onClick={getCms}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="card mb-4 px-4 py-4 mt-2" style={{ width: "100%" }}>
      <div className="card-heading mb-3">
        <div className="text-end mt-n5 mb-5">
          <button
            className="btn btn-primary bordered ml-2 weight-300 mt-n5 rounded-lg"
            onClick={() => navigate(`/customer/edit-terms-and-conditions`, { state: { role, title: "Terms And Conditions" } })}
          >
            <b>Edit</b>
          </button>
        </div>
        <div className="mt-3">
          <div className="row mx-n2">
            <div className="col-md-6 px-2 mb-3">
              <div className="rounded-14 border p-3 h-100">
                <h5 className="text-white mb-3">Terms &amp; Conditions (English)</h5>
                {data ? <div dangerouslySetInnerHTML={{ __html: data }} /> : <p>No English Terms and Conditions found</p>}
              </div>
            </div>
            <div className="col-md-6 px-2 mb-3">
              <div className="rounded-14 border p-3 h-100">
                <h5 className="text-white mb-3 text-right" dir="rtl">
                  الشروط والأحكام (Arabic)
                </h5>
                {dataArabic ? (
                  <div dir="rtl" dangerouslySetInnerHTML={{ __html: dataArabic }} />
                ) : (
                  <p className="text-right" dir="rtl">
                    لا توجد شروط وأحكام باللغة العربية
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
